import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { useOnClickOutside } from '@flywire/react-hooks';
import { Button } from './Button';
import { Provider, States, useDropdown } from './Context';
import { Item } from './Item';
import { Items } from './Items';
import { CLOSE_MENU } from './constants';
const DropdownComponent = forwardRef(({ as: Element = 'div', children, className, render, onChange = () => { }, ...rest }, ref) => {
    const internalRef = useRef(null);
    const { state, dispatch } = useDropdown();
    const isOpen = state === States.Open;
    useImperativeHandle(ref, () => internalRef.current, [internalRef]);
    useOnClickOutside(internalRef, () => {
        if (isOpen)
            onChange === null || onChange === void 0 ? void 0 : onChange(false);
        dispatch({ type: CLOSE_MENU });
    });
    useEffect(() => {
        onChange === null || onChange === void 0 ? void 0 : onChange(isOpen);
    }, [isOpen, onChange]);
    return (_jsx(Element, { "data-open": isOpen, ref: internalRef, className: className, ...rest, children: render ? render({ isOpen }) : children }));
});
DropdownComponent.displayName = 'Dropdown';
const Wrapper = forwardRef(({ as = 'div', className, children, onChange = () => { }, ...rest }, ref) => {
    return (_jsx(Provider, { ...rest, children: _jsx(DropdownComponent, { as: as, ref: ref, className: className, onChange: onChange, children: children }) }));
});
Wrapper.displayName = 'Dropdown';
const Dropdown = Wrapper;
Dropdown.Button = Button;
Dropdown.Item = Item;
Dropdown.Items = Items;
export { Dropdown };
//# sourceMappingURL=Dropdown.js.map